/* eslint-disable no-unused-vars */
import React, { lazy, Suspense } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';

const UserflowContainer = lazy(() => import('../../container/dashboard/overview/User-Flow/Userflow'));
const PlanExpiredPage = lazy(() => import('../../container/dashboard/overview/Plan-Expired/Plan-Expired'));

const UserflowRoute = () => {
  // const { path } = useRouteMatch();
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <PulseLoader color="#4285f4" loading size={15} aria-label="Loading Spinner" data-testid="loader" />
          </div>
        }
      >
        {/* <Route path="/onboarding" component={UserflowContainer} />
        <Route path="/plan-expired" component={PlanExpiredPage} /> */}
      </Suspense>
    </Switch>
  );
};

export default UserflowRoute;
